// extracted by mini-css-extract-plugin
export var assigneeBadge = "_id-0";
export var assigneeDetails = "_id-1";
export var assigneeInfo = "_id-2";
export var dropdownContainer = "_id-4";
export var dropdownImage = "_id-5";
export var editAssigneeInfo = "_id-3";
export var editAssigneeModalContainer = "_id-6";
export var hidden = "_id-8";
export var input = "_id-7";